export const REPAYMENT_COEFFICIENT = 0.2;
export const HEIGHT_COEFFICIENT = 0.65;
